import { useQuery } from '@tanstack/react-query';
import fetchAPI from '../fetchAPI';

interface Props {
  type?: string;
  status?: string;
  companyName?: string;
  pageNumber?: number;
  pageSize?: number;
  sortBy?: string | string[];
  /** Unique key to isolate this query cache from other useBillingAccounts callers */
  caller?: string;
}

export const useBillingAccounts = ({
  type,
  status,
  companyName,
  caller,
}: Props) => {

  const queryParams = new URLSearchParams();
  if (companyName) {
    queryParams.append('companyName', companyName);
  }
  if (type) {
    queryParams.append('type', type);
  }
  if (status && status !== 'both') {
    queryParams.append('status', status);
  }
 
  const queryString = queryParams.toString();

  return useQuery({
    queryKey: ['billing-accounts', caller ?? 'default', companyName, status, type],
    queryFn: async () => {
      const response = await fetchAPI<Pagination<BillingAccount>>({
        method: `GET`,
        route: `billing-accounts`,
        queryString
      });
      return response;
    },
    enabled: true,
  });
};

export default useBillingAccounts;
